<template>
    <div v-if="message || (items && items.length > 0)" aria-live="polite" class="error-message-formulaire" role="alert">
        <span class="error-text">{{ message }}</span>
        <ul v-if="items && items.length > 0" class="error-list">
            <li v-for="(item, index) in items" :key="index" class="error-list-item">{{ item }}</li>
        </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: 'ErrorMessageFormulaire',
    props: {
        message: {
            type: String,
            default: '',
        },
        items: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        maxHeight: {
            type: String,
            default: '120px',
        },
    },
});
</script>

<style scoped>
.error-message-formulaire {
    display: flex;
    flex-direction: column;
    gap: 4px;
    background-color: var(--rouge-error-background);
    border: 1px solid var(--rouge-error-border);
    border-left: 3px solid var(--etat-rouge);
    border-radius: 4px;
    padding: 6px 10px;
    margin-top: 4px;
    max-height: v-bind(maxHeight);
    overflow-y: auto;
}
.error-text {
    color: var(--etat-rouge);
    font-family: 'Roboto', sans-serif;
    font-size: var(--font-size-small);
}
.error-list {
    margin: 2px 0 0 16px;
    padding: 0;
    color: var(--etat-rouge);
    font-family: 'Roboto', sans-serif;
    font-size: var(--font-size-small);
}
.error-list-item {
    margin-bottom: 2px;
}
</style>
